import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';

export const ReasonsCheckboxGroup = ({ name, onChange, reasons, value = [] }) => {
  const selectedReasons = Array.isArray(value) ? value : [];

  const handleReasonToggle = reasonId => (_event, checked) => {
    const nextReasons = checked
      ? [...selectedReasons, reasonId]
      : selectedReasons.filter(currentReason => currentReason !== reasonId);

    onChange(nextReasons);
  };

  return (
    <FormGroup>
      {reasons.map(reason => (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={selectedReasons.includes(reason.id)}
              name={name}
              onChange={handleReasonToggle(reason.id)}
            />
          }
          key={reason.id}
          label={reason.title}
        />
      ))}
    </FormGroup>
  );
};
